// export const BaseGatewayImage = 'https://localhost:5001';
// export const BaseGateway = 'https://localhost:5001/api/v1';

// export const BaseGatewayAuthApi = 'https://localhost:5003/api/v1';
// export const BaseGatewayAuth = 'https://localhost:5003';
// export const BaseGatewayAuthImage = 'https://localhost:5003';

export const BaseGatewayImage = 'https://api.quanlytrangthietbi.cntt108.vn';
export const BaseGateway = 'https://api.quanlytrangthietbi.cntt108.vn/api/v1';

export const BaseGatewayAuthApi = 'https://api.authservice.cntt108.vn/api/v1';
export const BaseGatewayAuth = 'https://api.authservice.cntt108.vn';
export const BaseGatewayAuthImage = 'https://api.authservice.cntt108.vn';

// export const BaseGatewayImageAuth = 'http://localhost:5002';
// const BaseGatewayAuth = 'http://localhost:5002';

const BaseGatewayFromMainServer = 'http://108.108.108.52:10808';

export const BaseGatewayClient = 'http://interbgc.com.vn';

const BaseGatewayCrawler = 'http://crawlerapi.xecong.info'; 
// api chung lấy nguộn
export const AUTH_API = {
    LOGIN_API: `${BaseGatewayAuth}/connect/token`,
    REFRESHTOKEN_API: `${BaseGatewayAuth}/connect/token`,
    CHANGE_PASSWORD_API: `${BaseGatewayAuthApi}/Auth/ChangePassword`,
    FORGOT_PASSWORD: `${BaseGatewayAuth}/Auth/ForgotPassword`,
    RESET_PASSWORD: `${BaseGatewayAuth}/Auth/ResetPassword`
};

export const ACCOUNT_API = {
    GET_PAGING_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetAllPaging`,
    ADD_ACCOUNT: `${BaseGatewayAuthApi}/Account/Create`,
    EDIT_ACCOUNT: `${BaseGatewayAuthApi}/Account/Update`,
    DELETE_ACCOUNT: `${BaseGatewayAuthApi}/Account/DeleteItem`,
    GET_BY_ID_ACCOUNT: `${BaseGatewayAuthApi}/Account/GetItem`,
    COUNT_ALL_ACCOUNT_API: `${BaseGatewayAuthApi}/Account/CountAllAccount`
};

export const OPENIDDICTAPPLICATION_API = {
    GET_PAGING: `${BaseGatewayAuthApi}/OpeniddictApplication/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/GetItem`,
    ADD_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/OpeniddictApplication/DeleteItem`
};

export const FILE_MANAGER_API = {
    UPLOAD: `${BaseGateway}/FileManager/Upload`,
    GET_PAGING: `${BaseGateway}/FileManager/GetAllByPaging`,
    GET_DIR_PATH: `${BaseGateway}/FileManager/GetDirectoryPath`,
    DELETE: `${BaseGateway}/FileManager`
};

export const EMAILCONFIG_API = {
    GET_PAGING_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetAllByPaging`,
    GET_ITEM_EMAILCONFIG: `${BaseGateway}/EmailConfig/GetItem`,
    ADD_EMAILCONFIG: `${BaseGateway}/EmailConfig/CreateEmailConfig`,
    UPDATE_EMAILCONFIG: `${BaseGateway}/EmailConfig/UpdateItem`,
    DELETE_EMAILCONFIG: `${BaseGateway}/EmailConfig/DeleteItem`
};

export const LOGIN_HISTORY_API = {
    GET_PAGING_LOGIN: `${BaseGatewayAuth}/LoginHistory/GetAllPaging`,
    STATISTIC_LOGIN: `${BaseGatewayAuth}/LoginHistory/GetStatisticsLoginByAccount`,
    STATISTIC_COUNT_LOGIN_BY_DATE: `${BaseGatewayAuth}/LoginHistory/CountAllByDate`
};

export const LOG_API = {
    GET_PAGING_LOG: `${BaseGateway}/Log/GetAllByPaging`,
    DELETE_LOG: `${BaseGateway}/Log/DeleteByDate`,
    COUNT_LOG_BY_DATE: `${BaseGateway}/Log/CountLogsByDate`
};

export const TIMELINE_API = {
    GET_PAGING: `${BaseGateway}/AssetActivityLog/GetByAssetId`
};

// export const APIROLEMAPPING_API = {
//     GET_PAGING: `${BaseGateway}/ApiRoleMapping/GetAllByPaging`,
//     GET_ITEM: `${BaseGateway}/ApiRoleMapping/GetItem`,
//     ADD_ITEM: `${BaseGateway}/ApiRoleMapping/Create`,
//     UPDATE_ITEM: `${BaseGateway}/ApiRoleMapping/UpdateItem`,
//     DELETE_ITEM: `${BaseGateway}/ApiRoleMapping/DeleteItem`,
//     BULK_ASSIGN_ROLES: `${BaseGateway}/ApiRoleMapping/BulkAssignRoles`
// };

export const APIROLEMAPPING_API = {
    GET_PAGING: `${BaseGateway}/ApiRoleMapping/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ApiRoleMapping/GetItem`,
    ADD_ITEM: `${BaseGateway}/ApiRoleMapping/Create`,
    UPDATE_ITEM: `${BaseGateway}/ApiRoleMapping/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ApiRoleMapping/DeleteItem`,
    BULK_ASSIGN_ROLES: `${BaseGateway}/ApiRoleMapping/BulkAssignRoles`
};

export const ROLE_API = {
    GET_ALL: `${BaseGatewayAuthApi}/Role/GetAll`,
    GET_PAGING: `${BaseGatewayAuthApi}/Role/GetAllByPaging`,
    GET_ITEM: `${BaseGatewayAuthApi}/Role/GetItem`,
    ADD_ITEM: `${BaseGatewayAuthApi}/Role/Create`,
    UPDATE_ITEM: `${BaseGatewayAuthApi}/Role/UpdateItem`,
    DELETE_ITEM: `${BaseGatewayAuthApi}/Role/DeleteItem`,
    UPDATE_TREE: `${BaseGatewayAuthApi}/Role/UpdateTree`
};

export const MENU_API = {
    GET_PAGING: `${BaseGateway}/MenuItem/GetAllByPaging`,
    GET_MENU: `${BaseGateway}/MenuItem/GetMenu`,
    GET_ITEM: `${BaseGateway}/MenuItem/GetItem`,
    ADD_ITEM: `${BaseGateway}/MenuItem/Create`,
    UPDATE_ITEM: `${BaseGateway}/MenuItem/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/MenuItem/DeleteItem`,
    UPDATE_TREE: `${BaseGateway}/MenuItem/UpdateTree`
};

export const DEPARTMENT_API = {
    GET_PAGING: `${BaseGateway}/Department/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/Department/GetItem`,
    ADD_ITEM: `${BaseGateway}/Department/Create`,
    UPDATE_ITEM: `${BaseGateway}/Department/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/Department/DeleteItem`,
    GET_ALL: `${BaseGateway}/Department/GetAll`
};

export const MATERIALCATALOG_API = {
    GET_PAGING: `${BaseGateway}/MaterialCatalog/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/MaterialCatalog/GetItem`,
    ADD_ITEM: `${BaseGateway}/MaterialCatalog/Create`,
    UPDATE_ITEM: `${BaseGateway}/MaterialCatalog/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/MaterialCatalog/DeleteItem`,
    GET_BY_LIST_ID: `${BaseGateway}/MaterialCatalog/GetByListId`,
    GET_ALL: `${BaseGateway}/MaterialCatalog/GetAll`,
    BULK_IMPORT: `${BaseGateway}/MaterialCatalog/BulkImport`,
    DOWNLOAD_TEMPLATE: `${BaseGateway}/MaterialCatalog/DownloadTemplate`
};

export const MAINTENANCE_PLAN_API = {
    GET_PAGING: `${BaseGateway}/MaintenancePlan/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/MaintenancePlan/GetItem`,
    ADD_ITEM: `${BaseGateway}/MaintenancePlan/Create`,
    UPDATE_ITEM: `${BaseGateway}/MaintenancePlan/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/MaintenancePlan/DeleteItem`
};

export const MAINTENANCE_PLAN_MATERIAL_API = {
    GET_BY_PLAN: `${BaseGateway}/MaintenancePlanMaterial/GetByPlanId`,
};

export const MAINTENANCE_EVENT_API = {
    GET_PAGING: `${BaseGateway}/AssetMaintenanceEvent/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/AssetMaintenanceEvent/GetItem`,
    ADD_ITEM: `${BaseGateway}/AssetMaintenanceEvent/Create`,
    UPDATE_ITEM: `${BaseGateway}/AssetMaintenanceEvent/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/AssetMaintenanceEvent/DeleteItem`,
    APPROVE: `${BaseGateway}/AssetMaintenanceEvent/Approve`,
    REJECT: `${BaseGateway}/AssetMaintenanceEvent/Reject`,
    COMPLETE: `${BaseGateway}/AssetMaintenanceEvent/Complete`,
    BULK_CREATE: `${BaseGateway}/AssetMaintenanceEvent/BulkCreate`, // #viet_code
    GET_ALERT_COUNTS: `${BaseGateway}/AssetMaintenanceEvent/GetAlertCounts`,
    GET_BY_ASSET_ID: `${BaseGateway}/AssetMaintenanceEvent/GetByAssetId`
};

export const MAINTENANCE_BATCH_API = {
    GET_PAGING: `${BaseGateway}/MaintenanceBatch/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/MaintenanceBatch/GetDetail`,
    CREATE: `${BaseGateway}/MaintenanceBatch/Create`,
    UPDATE: `${BaseGateway}/MaintenanceBatch/Update`,
    CANCEL: `${BaseGateway}/MaintenanceBatch/Cancel`,
    DELETE: `${BaseGateway}/MaintenanceBatch/DeleteBatch`,
    CHECK_IN_REPAIR: `${BaseGateway}/MaintenanceBatch/CheckAssetInRepair`,
    APPROVE: `${BaseGateway}/MaintenanceBatch/Approve`,
    UNAPPROVE: `${BaseGateway}/MaintenanceBatch/Unapprove`,
    REJECT: `${BaseGateway}/MaintenanceBatch/Reject`,
    COMPLETE: `${BaseGateway}/MaintenanceBatch/Complete`,
};

export const MAINTENANCE_EVENT_MATERIAL_API = {
    GET_BY_EVENT: `${BaseGateway}/MaintenanceEventMaterial/GetByEventId`,
    GET_PAGING: `${BaseGateway}/MaintenanceEventMaterial/GetAllByPaging`,
    ADD_ITEM: `${BaseGateway}/MaintenanceEventMaterial/Create`,
    UPDATE_ITEM: `${BaseGateway}/MaintenanceEventMaterial/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/MaintenanceEventMaterial/DeleteItem`,
};
export const ASSET_ACCESSORY_API = {
    ADD_ITEM: `${BaseGateway}/AssetAccessory/Create`,
    UPDATE_ITEM: `${BaseGateway}/AssetAccessory/UpdateItem`,
    GET_BY_ASSET_ID: `${BaseGateway}/AssetAccessory/GetByAsset`
};
// #viet_code — Giao dịch vật tư thực tế trong sự kiện sửa chữa
export const ASSET_ACCESSORY_TRANSACTION_API = {
    GET_PAGING: `${BaseGateway}/AssetAccessoryTransaction/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/AssetAccessoryTransaction/GetItem`,
    ADD_ITEM: `${BaseGateway}/AssetAccessoryTransaction/Create`,
    UPDATE_ITEM: `${BaseGateway}/AssetAccessoryTransaction/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/AssetAccessoryTransaction/DeleteItem`,
};

export const ASSET_API = {
    GET_PAGING: `${BaseGateway}/Asset/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/Asset/GetItem`,
    ADD_ITEM: `${BaseGateway}/Asset/Create`,
    UPDATE_ITEM: `${BaseGateway}/Asset/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/Asset/DeleteItem`,
    UPDATE_FIELD: `${BaseGateway}/Asset/UpdateField`,
    GET_PUBLIC_ITEM: `${BaseGateway}/Asset/GetPublicDetail`,
    GET_STATUS_STATS: `${BaseGateway}/Asset/GetStatusStatistics`,
    GET_DEPT_STATS: `${BaseGateway}/Asset/GetDepartmentStatistics`,
    GET_GROUP_STATS: `${BaseGateway}/Asset/GetGroupStatusStatistics`,
    BULK_IMPORT: `${BaseGateway}/Asset/BulkImport`,
    DOWNLOAD_TEMPLATE: `${BaseGateway}/Asset/DownloadTemplate`,
    EXPORT_REPORT: `${BaseGateway}/Asset/ExportReport`,
    GET_BY_QR: `${BaseGateway}/Asset/GetByQrCode`,
    ASSIGN_QR: `${BaseGateway}/Asset/AssignQrCode`,
};

export const ASSETSTATUS_API = {
    GET_PAGING: `${BaseGateway}/AssetStatus/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/AssetStatus/GetItem`,
    ADD_ITEM: `${BaseGateway}/AssetStatus/Create`,
    UPDATE_ITEM: `${BaseGateway}/AssetStatus/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/AssetStatus/DeleteItem`,
};

export const ASSETGROUP_API = {
    GET_PAGING: `${BaseGateway}/AssetGroup/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/AssetGroup/GetItem`,
    ADD_ITEM: `${BaseGateway}/AssetGroup/Create`,
    UPDATE_ITEM: `${BaseGateway}/AssetGroup/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/AssetGroup/DeleteItem`,
};

export const ASSETTRANSFER_API = {
    GET_PAGING: `${BaseGateway}/AssetTransfer/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/AssetTransfer/GetItem`,
    ADD_ITEM: `${BaseGateway}/AssetTransfer/Create`,
    UPDATE_ITEM: `${BaseGateway}/AssetTransfer/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/AssetTransfer/DeleteItem`,
    GET_BY_ASSET_ID: `${BaseGateway}/AssetTransfer/GetByAssetId`
};
// API Kiểm kê mới (Phase 3)
export const INVENTORY_SESSION_API = {
    GET_PAGING: `${BaseGateway}/InventorySession/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/InventorySession/GetItem`,
    CREATE: `${BaseGateway}/InventorySession/Create`,
    GET_SNAPSHOTS: `${BaseGateway}/InventorySession/GetSnapshots`,
    GET_DISPOSAL_CANDIDATES: `${BaseGateway}/InventorySession/GetDisposalCandidates`,
    GET_HISTORY_BY_ASSET: (assetId) => `${BaseGateway}/InventorySession/GetHistoryByAsset/${assetId}`,
    CANCEL: (id) => `${BaseGateway}/InventorySession/Cancel/${id}`,
};

export const USAGEPURPOSE_API = {
    GET_PAGING: `${BaseGateway}/UsagePurpose/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/UsagePurpose/GetItem`,
    ADD_ITEM: `${BaseGateway}/UsagePurpose/Create`,
    UPDATE_ITEM: `${BaseGateway}/UsagePurpose/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/UsagePurpose/DeleteItem`,
};

export const EQUIPMENTTYPE_API = {
    GET_PAGING: `${BaseGateway}/EquipmentType/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/EquipmentType/GetItem`,
    ADD_ITEM: `${BaseGateway}/EquipmentType/Create`,
    UPDATE_ITEM: `${BaseGateway}/EquipmentType/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/EquipmentType/DeleteItem`,
};

export const EQUIPMENTSOURCE_API = {
    GET_PAGING: `${BaseGateway}/EquipmentSource/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/EquipmentSource/GetItem`,
    ADD_ITEM: `${BaseGateway}/EquipmentSource/Create`,
    UPDATE_ITEM: `${BaseGateway}/EquipmentSource/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/EquipmentSource/DeleteItem`,
};

export const FUNDINGSOURCE_API = {
    GET_PAGING: `${BaseGateway}/FundingSource/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/FundingSource/GetItem`,
    ADD_ITEM: `${BaseGateway}/FundingSource/Create`,
    UPDATE_ITEM: `${BaseGateway}/FundingSource/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/FundingSource/DeleteItem`,
};

export const QUALITYLEVEL_API = {
    GET_PAGING: `${BaseGateway}/QualityLevel/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/QualityLevel/GetItem`,
    ADD_ITEM: `${BaseGateway}/QualityLevel/Create`,
    UPDATE_ITEM: `${BaseGateway}/QualityLevel/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/QualityLevel/DeleteItem`,
};

export const CONNECTIONTYPE_API = {
    GET_PAGING: `${BaseGateway}/ConnectionType/GetAllByPaging`,
    GET_ITEM: `${BaseGateway}/ConnectionType/GetItem`,
    ADD_ITEM: `${BaseGateway}/ConnectionType/Create`,
    UPDATE_ITEM: `${BaseGateway}/ConnectionType/UpdateItem`,
    DELETE_ITEM: `${BaseGateway}/ConnectionType/DeleteItem`,
};

export const ASSET_DISPOSAL_API = {
    GET_PAGING: `${BaseGateway}/AssetDisposal/GetPaging`,
    GET_CANDIDATES: `${BaseGateway}/AssetDisposal/GetCandidates`,
    GET_ITEM: `${BaseGateway}/AssetDisposal/GetItem`,
    GET_ASSETS: `${BaseGateway}/AssetDisposal/GetAssets`,
    ADD_ITEM: `${BaseGateway}/AssetDisposal/Create`,
    CANCEL: `${BaseGateway}/AssetDisposal/Cancel`,
    EXPORT_EXCEL: (id) => `${BaseGateway}/AssetDisposal/ExportExcel/${id}`
};

